import CourseHeader from "../components/CourseHeader";
import CourseList from "../section/mycoursepage/CourseList";
import CourseDetail from "../section/mycoursepage/CourseDetail";

export default function MyCoursePage(){
    return(
        <div>
            <CourseHeader />
        <CourseList/>
        </div>
    )
}